import styled from "styled-components";

export const Container = styled.ul`
	display: flex;
	align-items: center;
	gap: 0.5rem;

	list-style: none;

	background-color: var(--neutral-strong);
	min-height: 2.5rem;

	padding: 5px;
	border-radius: 8px;
	width: 100%;
	height: 2.5rem;
	margin-bottom: unset;
`;

export const NavItem = styled.li`
	width: 100%;

	display: flex;
	align-items: center;
`;

export const NavLink = styled.a`
	border-radius: 8px;
	width: 100%;
	padding: 0.313rem;

	text-align: center;

	font-family: var(--font-family-metropolis-semi-bold);

	&.selected {
		background-color: var(--brand-primary);
		color: var(--neutral-strongest) !important;
	}

	&.unselected {
		background-color: transparent;
		color: var(--neutral-smoothest) !important;
	}
`;
